import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapper: BoxProps = {};
export const FooterRowContainer: CSSObject = {
  '&&:nth-child(1)': {
    mb: '2',
  },
};
